// import moment from 'moment'
import format from 'date-fns/format'
import uniqBy from 'lodash/uniqBy'
import throttle from 'lodash/throttle'
import inRange from 'lodash/inRange'
import {
  sortAsc,
  sortDesc,
  sortTimeAsc,
  sortTimeDesc
} from './utils'
const locales = {
  en: require('date-fns/locale/en'),
  fi: require('date-fns/locale/fi')
}

const siteLocale = document.getElementsByTagName('html')[0].attributes[0].value

// console.log(eventzFeedStrings)

export default function ($) {
  let dataLayer = []
  // pull settings from data-attributes, we get these from the function inject_settings_to_html() in the plugin php class.
  const localizedFormat = (dateString, formatString) => {
    return format(dateString, formatString, {
      locale: locales[siteLocale.slice(0, 2) || 'en']
    })
  }  

  const buildError = (error) => {
    console.log(error)
    $('.eventz-feeds-container').html(() => 'Please provide a valid default endpoint in plugin settings!')
  }

  const filtersHtml = (defaultSort = 'no default') => {
    return `
            <div class="eventzplugin__filters">
                <div class="eventzplugin__sort-label">${eventzFeedStrings.sortByLabel}</div>
                <div class="eventzplugin__sort-button eventzplugin__sort-button--bytime ${defaultSort == 'time' ? 'descending' : ''}">${eventzFeedStrings.sortByTime}</div>
                <div class="eventzplugin__sort-button eventzplugin__sort-button--byname ${defaultSort == 'name' ? 'descending' : ''}">${eventzFeedStrings.sortByName}</div>
            </div>
        `
  }

  const getStyleByContainerWidth = (element) => {
    const elementWidth = $(element).width()
    if (elementWidth < 400) {
      return 'small'
    } else if (inRange(elementWidth, 400, 720)) {
      return 'medium'
    } else if (inRange(elementWidth, 721, 1099)) {
      return 'large'
    } else if (elementWidth > 1100) {
      return 'huge'
    }
  }

  const sortByName = function ($container, $button) {
    $button.parent().find('div.eventzplugin__sort-button--bytime').removeClass('ascending descending')
    const dataOb = getContainerData($container.data().eventzEndpoint)

    $container.removeData('sortOrderTime')
    $button.toggleClass('ascending', $button.hasClass('descending'))
    $button.toggleClass('descending', !$button.hasClass('descending'))

    if ($button.hasClass('ascending')) {
      return {
        ...dataOb,
        items: dataOb.items.sort(sortAsc)
      }
    } else {
      return {
        ...dataOb,
        items: dataOb.items.sort(sortDesc)
      }
    }
  }

  const sortByTime = function ($container, $button) {
    $button.parent().children('div.eventzplugin__sort-button--byname').removeClass('ascending descending')
    const dataOb = getContainerData($container.data().eventzEndpoint)
    $button.toggleClass('ascending', $button.hasClass('descending'))
    $button.toggleClass('descending', !$button.hasClass('descending'))
    if ($button.hasClass('ascending')) {
      return {
        ...dataOb,
        items: dataOb.items.sort(sortTimeAsc)
      }
    } else {
      return {
        ...dataOb,
        items: dataOb.items.sort(sortTimeDesc)
      }
    }
  }

  const render = (dataOb, amountToRender) => {
    const element = dataOb.endpoint ? $(`.eventz-feeds-container[data-eventz-endpoint ="${dataOb.endpoint}" ] `) : this
    const style = getStyleByContainerWidth(element)
    buildHtml.call(element, dataOb, style, amountToRender || cutPoint(element))
  }
  const firstRender = (dataOb) => {
    const element = dataOb.endpoint ? $(`.eventz-feeds-container[data-eventz-endpoint ="${dataOb.endpoint}" ] `) : this
    const style = getStyleByContainerWidth(element)
    const defaultSort = element.data().eventzSort_by
    const sortedItems = items => {
        if (defaultSort == 'name') {
            return items.sort(sortDesc)
        }
        else if (defaultSort == 'time') {
            return items.sort(sortTimeDesc)
        }
        return items
    }

    const sortedDataOb = {
        ...dataOb,
        items: sortedItems(dataOb.items)
    }
    buildHtml.call(element, sortedDataOb, style, cutPoint(element))
  }

  const getContainerData = (endpoint) => {
    return dataLayer.find(item => item.endpoint == endpoint)
  }

  const updateView = () => {
    const $containers = $('.eventz-feeds-container')
    $containers.each(function () {
      const amountLoaded = $(this).find('li').get().length
      const data = getContainerData($(this).data().eventzEndpoint)
      render(data, amountLoaded)
    })
  }

  const handleAjaxErrors = (response) => {
    if (!response.ok) {
      throw Error(response.status)
    }
    return response.json()
  }

  const getDateString = (startDate, endDate) => {
    if (localizedFormat(startDate, 'D.M.YYYY') == localizedFormat(endDate, 'D.M.YYYY')) return localizedFormat(startDate, 'ddd D.M.YYYY - HH:mm')
    return localizedFormat(startDate, 'D.M') + ' - ' + localizedFormat(endDate, 'D.M.YYYY')
  }

  function loadMore() {
    const $container = $(this)
    const amountToLoad = cutPoint(this) * 2
    const amountLoaded = $container.find('li').get().length
    const data = getContainerData($container.data().eventzEndpoint)
    render(data, amountLoaded + amountToLoad)
  }

  const cutPoint = element => {
    const elementWidth = $(element).width()
    if (elementWidth < 400) {
      return 1
    } else if (inRange(elementWidth, 400, 720)) {
      return 2
    } else if (inRange(elementWidth, 721, 1099)) {
      return 3
    } else if (elementWidth > 1100) {
      return 4
    }
  }

  function buildHtml(response, style = '', amountToLoad = 3) {
    var $container = $(this)

    let eventsListHtml = response.items.map(createTemplate.bind(this, style)).slice(0, amountToLoad)
    $(this).html(() => `<ul class="eventzplugin__list">${eventsListHtml.join('')}</ul>`)

    const eventsVisible = $(this).find('li').get().length

    // show buttons based on endpoint licence and amount of events visible
    if (response.licence && response.licence == 'FREE') {
      $(this).children('ul').after(`<a href="${response.urlFrontend}" alt="${response.urlFrontend}"><button class="eventzplugin__external-link-button">${eventzFeedStrings.readmoreExternal}</button></a>`)
    } else if (response.licence && response.items.length > cutPoint(this) && eventsVisible < response.items.length) {
      $(this).children('ul').after(`<button class="eventzplugin__loadmore-button">${eventzFeedStrings.readmore}</button>`)
    }
    $(this).find('button.eventzplugin__loadmore-button').on('click', loadMore.bind(this, response.items))
    $container.animate({
      opacity: 1
    }, 100)
  }

  const createTemplate = (style, event) => {
    if (!style) style = "detailed";
    // function that builds and returns a html template from event data
    var timeString = '';
    if (event.startDate && event.endDate) timeString = '<div class="eventzplugin__event-time">' + getDateString(event.startDate, event.endDate) + '</div>';

    return `
            <li class="eventzplugin__list-item eventzplugin__list-item--${style}">
                <img class="eventzplugin__event-image" src="https://s3.eu-central-1.amazonaws.com/eventz.today.prod/images/${event.imageMobile}" />
                <div class="eventzplugin__event-content">
                    ${timeString}
                    <a href="${event.itemUrl}" alt="${event.name}"><div class="eventzplugin__event-title eventzplugin__event-title--full">${event.name.slice(0,100)}...</div></a>
                    <a href="${event.itemUrl}" alt="${event.name}"><div class="eventzplugin__event-title eventzplugin__event-title--concat">${event.name.slice(0,60)}...</div></a>
                    <div class="eventzplugin__event-location">${event.location.address ? event.location.address : event.location.name + ' - ' + event.location.streetAddress + ', ' + event.location.addressLocality }</div>
                    <div class="eventzplugin__event-description">${event.description.slice(0,100)}...</div>
                </div>
            </li>
        `
  }
  const saveToDataLayer = function (endpoint, response) {
    // console.log(response)
    const ob = {
      endpoint,
      ...response
    }
    dataLayer.push(ob)
    firstRender(ob)
  }
  const getData = function () {
    const endpoint = $(this).data().eventzEndpoint
    fetch(endpoint)
      .then(handleAjaxErrors)
      .then(saveToDataLayer.bind(this, endpoint)) //bind this to the jQuery element at hand
      .catch(buildError)
  }

  const init = () => {
    const $containers = $('.eventz-feeds-container')
    // add layout class from settings
    $containers.each(function () {
      $(this).before(filtersHtml($(this).data().eventzSort_by))
      $(this).addClass($(this).data().eventzLayoutStyle)
    })
    // get settings to an array to check for endpoint uniqueness. If there's duplicates we don't to perform multiple requests
    const elementSettings = $containers.map(function () {
      return $(this).data()
    }).get()
    uniqBy(elementSettings, 'eventzEndpoint').length > 1 ? $containers.each(getData) : getData.call($containers[0], 0)
    $('div.eventzplugin__sort-button--byname').on('click', function (e) {
      const $container = $(this).parent().next()
      const $button = $(e.target)
      const eventsVisible = $container.find('li').get().length
      $container.animate({
        opacity: 0
      }, 200, () => {
        render(sortByName.call(null, $container, $button), eventsVisible)
      })
    })
    $('div.eventzplugin__sort-button--bytime').on('click').on('click', function (e) {
      const $container = $(this).parent().next()
      const eventsVisible = $container.find('li').get().length
      const $button = $(e.target)
      $container.animate({
        opacity: 0,
      }, 100, () => {
        render(sortByTime.call(null, $container, $button), eventsVisible)
      })
    })
    $(window).on('resize', throttle(updateView, 500))
  }
  init()

}



// WEBPACK FOOTER //
// ./src/js/main.js